import React, { useState, useEffect, useRef } from 'react';
import { Field, ErrorMessage } from 'formik';
import { OverlayTrigger, Popover, Tooltip } from 'react-bootstrap';
import { ChromePicker } from 'react-color';

const CMSFormColor = (props) => {
    const { name, label, form, required, color, helpMessage, ...rest } = props;
    const [showPicker, setShowPicker] = useState(false);
    const [selectedColor, setSelectedColor] = useState('#ffffff');
    const colorPickerRef = useRef(null);
    const fieldRef = useRef(null);

    useEffect(() => {
        const handleOutsideClick = (event) => {
            // Close the color picker if clicked outside of it
            if (
                colorPickerRef.current &&
                !colorPickerRef.current.contains(event.target) &&
                fieldRef.current &&
                !fieldRef.current.contains(event.target)
            ) {
                console.log("Closing color picker");
                setShowPicker(false);
            }
        };
    
        // Add event listener when the component mounts
        document.addEventListener('mousedown', handleOutsideClick);
    
        // Remove event listener when the component unmounts
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);

    const handleColorChange = (color) => {
        setSelectedColor(color.hex);
        form.setFieldValue(name, color.hex);
    };

    const handleButtonClick = () => {
        setShowPicker(!showPicker);
    };

    return (
        <div className="form-group position-relative" ref={colorPickerRef}>
            {/* Created Useable Component */}
            {
                (label !== "") &&
                <>
                    {
                        (required === true)
                            ? <OverlayTrigger
                                key={`tooltip-${name}`}
                                placement='right'
                                overlay={
                                    <Tooltip id={`tooltip-right`}>
                                        Required field.
                                    </Tooltip>
                                }
                            ><label htmlFor={name} className={`required ' ${(form.touched[name] && form.errors[name]) ? "is-invalidText" : ""}`}> {label}</label></OverlayTrigger>
                            : <label htmlFor={name} className={` ${(form.touched[name] && form.errors[name]) ? "is-invalidText d-flex align-items-center" : "d-flex align-items-center"}`}> {label}

                            </label>
                    }
                </>
            }

            {/* Created Useable Component */}
            {
                (helpMessage && helpMessage.message)
                && <OverlayTrigger
                    trigger='hover'
                    key={`info-popup-${name}`}
                    placement="right"
                    overlay={
                        <Popover id={`popover-positioned-${name}`}>

                            {
                                (helpMessage.heading) &&
                                <Popover.Header as="h3">{helpMessage.heading}</Popover.Header>

                            }


                            <Popover.Body>
                                {helpMessage.message}
                            </Popover.Body>
                        </Popover>
                    }
                ><i className="fa fa-info-circle ml-2 infoIcon"></i></OverlayTrigger>
            }



            <div className=''>
                <Field
                    name={name}
                    onClick={handleButtonClick}
                     style={{ paddingLeft: '30px'}}
                    className={` form-control ${(form.touched[name] && form.errors[name]) ? 'is-invalid moveRight' : 'moveRight'}`}
                    {...rest}
                    innerRef={fieldRef}
                />
 {form.touched[name] && form.errors[name] && (
               <span id={`${name}-error"`} className="error invalid-feedback">
                 <ErrorMessage name={name} />
               </span>
             )}
                <div style={{ marginTop: '5px',borderRadius:"2px", backgroundColor: form.values[name], height: '15px', width: '15px', position: "absolute", top: "39px", left: "10px" }} />

                <div ref={colorPickerRef} style={{ marginTop: '0px', border: "0px solid #ccc", width: "250px" }}>
                    {showPicker && (
                        <div style={{ marginTop: '20px', border: "0px solid #ccc", width: "250px" }}>
                            <ChromePicker color={form.values[name]} onChange={handleColorChange} />
                        </div>
                    )}
                </div>
            </div>
       
            
        </div>
    )
};

export default CMSFormColor;
